import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Manifesto from "@/components/landing/Manifesto";
import Services from "@/components/landing/Services";
import Emergency from "@/components/landing/Emergency";
import Reviews from "@/components/landing/Reviews";
import Gallery from "@/components/landing/Gallery";
import QuoteForm from "@/components/landing/QuoteForm";
import Footer from "@/components/landing/Footer";

export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-[#050505] text-white min-h-screen" data-testid="app-root">
      <Toaster theme="dark" position="top-center" />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Services />
        <Gallery />
        <Emergency />
        <Reviews />
        <QuoteForm />
      </main>
      <Footer />
    </div>
  );
}

export default App;
